import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "./ThemeContext";
// Removed GTranslate component; using global script widget instead

function Navbar() {
  const { t, i18n } = useTranslation();
  const { dark, toggleTheme } = useTheme();
  const [user, setUser] = useState(null);

  // scheme: false = mandal (default), true = kanchan
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) setUser(JSON.parse(userData));

    const savedScheme = localStorage.getItem("schemeType");
    setChecked(savedScheme === "kanchan");

    // init bootstrap dropdowns if bootstrap is present
    const initDropdowns = () => {
      if (typeof window !== "undefined" && window.bootstrap) {
        const dropdownElementList =
          document.querySelectorAll(".dropdown-toggle");
        dropdownElementList.forEach((el) => {
          const instance = window.bootstrap.Dropdown.getInstance(el);
          if (instance) instance.dispose();
          new window.bootstrap.Dropdown(el);
        });
      }
    };

    // small delay so markup exists
    setTimeout(initDropdowns, 100);

    const handleLanguageChange = () => setTimeout(initDropdowns, 50);
    const handleClickOutside = (e) => {
      const dropdowns = document.querySelectorAll(".dropdown-menu.show");
      dropdowns.forEach((dropdown) => {
        if (
          !dropdown.contains(e.target) &&
          !e.target.closest(".dropdown-toggle")
        ) {
          dropdown.classList.remove("show");
        }
      });
    };

    window.addEventListener("languageChanged", handleLanguageChange);
    document.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("languageChanged", handleLanguageChange);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleToggle = (type) => {
    const currentScheme = checked ? "kanchan" : "mandal";
    const isKanchan = type === "kanchan";

    if (currentScheme === type) return;

    setChecked(isKanchan);
    localStorage.setItem("schemeType", type);

    window.dispatchEvent(
      new CustomEvent("schemeChanged", {
        detail: { from: currentScheme, to: type },
      })
    );
  };

  // convenience wrapper for buttons (prevents navigation default)
  const handleSchemeSelect = (type, e) => {
    if (e && e.preventDefault) e.preventDefault();
    handleToggle(type);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    window.dispatchEvent(new Event("languageChanged"));
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return t("goodMorning", { name: user?.name || "User" });
    else if (hour < 17)
      return t("goodAfternoon", { name: user?.name || "User" });
    else return t("goodEvening", { name: user?.name || "User" });
  };


  const selectLanguage = (lng, e) => {
    e.preventDefault();
    changeLanguage(lng);
    const dropdownMenu = e.target.closest(".dropdown-menu");
    if (dropdownMenu) dropdownMenu.classList.remove("show");
  };


  return (
    <>
      <div className="topbar d-print-none">
        <div className="container-xxl">
          <nav
            className="topbar-custom d-flex justify-content-between align-items-center"
            id="topbar-custom"
          >
            <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
              <li>
                <button
                  className="nav-link mobile-menu-btn nav-icon"
                  id="togglemenu"
                >
                  <i className="iconoir-menu-scale" />
                </button>
              </li>
              <li className="welcome-text">
                <h3 className="mb-0 fw-bold text-truncate">{getGreeting()}</h3>
              </li>
            </ul>

            <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0 gap-2">
              {/* Scheme switch */}
              <li className="topbar-item">
                <div id="schemeDropdownToggle" className="scheme-chip">
                  <div className={`scheme-chip-icon ${checked ? "is-kanchan" : "is-mandal"}`}>
                    <img
                      src={checked ? "assets/images/kanchan.png" : "assets/images/mandal.png"}
                      alt=""
                    />
                  </div>
                  <div className="scheme-chip-text">
                    <span className="scheme-chip-label">Scheme</span>
                    <span className="scheme-chip-name">
                      {checked ? "Kanchanvarsha" : "Monthly Saving"}
                    </span>
                  </div>
                  <button
                    type="button"
                    className={`scheme-chip-switch ${checked ? "is-on" : ""}`}
                    onClick={(e) =>
                      handleSchemeSelect(checked ? "mandal" : "kanchan", e)
                    }
                    aria-label="Switch scheme"
                    title="Switch scheme"
                  >
                    <i className="fas fa-exchange-alt" />
                  </button>
                </div>
              </li>

              {/* Theme toggle */}
              <li className="topbar-item">
                <a
                  className="nav-link nav-icon"
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTheme();
                  }}
                >
                  <i className="icofont-moon dark-mode" />
                  <i className="icofont-sun light-mode" />
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <style>
          {`
            .scheme-chip {
              display: inline-flex;
              align-items: center;
              gap: 10px;
              padding: 6px 8px 6px 8px;
              border-radius: 14px;
              background: var(--bs-body-bg);
              border: 1px solid rgba(75, 44, 59, 0.1);
              box-shadow: 0 2px 8px rgba(75, 44, 59, 0.05);
            }

            .scheme-chip-icon {
              width: 36px;
              height: 36px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            }

            .scheme-chip-icon.is-mandal {
              background: rgba(211, 175, 55, 0.18);
            }

            .scheme-chip-icon.is-kanchan {
              background: rgba(75, 44, 59, 0.12);
            }

            .scheme-chip-icon img {
              width: 24px;
              height: 24px;
              object-fit: contain;
            }

            .scheme-chip-text {
              display: flex;
              flex-direction: column;
              min-width: 0;
              padding-right: 4px;
            }

            .scheme-chip-label {
              font-size: 10px;
              font-weight: 600;
              letter-spacing: 0.05em;
              text-transform: uppercase;
              color: var(--bs-secondary-color);
              line-height: 1.2;
            }

            .scheme-chip-name {
              font-size: 13px;
              font-weight: 700;
              color: #4B2C3B;
              white-space: nowrap;
              line-height: 1.25;
            }

            .scheme-chip-switch {
              width: 34px;
              height: 34px;
              border: none;
              border-radius: 50%;
              padding: 0;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              background: rgba(75, 44, 59, 0.08);
              color: #4B2C3B;
              cursor: pointer;
              flex-shrink: 0;
              transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
            }

            .scheme-chip-switch i {
              font-size: 13px;
            }

            .scheme-chip-switch.is-on {
              background: linear-gradient(135deg, #D3AF37, #B8941F);
              color: #4B2C3B;
            }

            .scheme-chip-switch:hover {
              transform: rotate(180deg);
            }

            [data-bs-theme="dark"] .scheme-chip {
              border-color: rgba(255, 255, 255, 0.1);
            }

            [data-bs-theme="dark"] .scheme-chip-name {
              color: #F0D78C;
            }

            [data-bs-theme="dark"] .scheme-chip-switch {
              background: rgba(255, 255, 255, 0.1);
              color: #F0D78C;
            }

            [data-bs-theme="dark"] .scheme-chip-switch.is-on {
              background: linear-gradient(135deg, #D3AF37, #B8941F);
              color: #4B2C3B;
            }

            @media (max-width: 768px) {
              .scheme-chip {
                gap: 8px;
                padding: 5px 7px;
              }

              .scheme-chip-icon {
                width: 32px;
                height: 32px;
              }

              .scheme-chip-icon img {
                width: 20px;
                height: 20px;
              }

              .scheme-chip-name {
                font-size: 12px;
              }
            }

            @keyframes schemeSwitch {
              0% { transform: scale(1); }
              50% { transform: scale(1.015); }
              100% { transform: scale(1); }
            }

            .scheme-chip.switching {
              animation: schemeSwitch 0.35s ease;
            }
          `}
        </style>
      </div>
    </>
  );
}

export default Navbar;
